import React from "react";
import PropTypes from "prop-types";

const propTypes = {
    style: PropTypes.object
};

const defaultProps = {
    style: {}
};

const Label = ({ style }) => {
    const { width = "24", height = "24.002" } = style;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24.002">
            <path id="icon-label" d="M13.9,2a1.782,1.782,0,0,0-1.255.457L2.408,12.693A1.387,1.387,0,0,0,2,13.671a1.35,1.35,0,0,0,.408.962l1.728,1.728a2.368,2.368,0,0,1,.652-1.272L15.043,4.851a3.135,3.135,0,0,1,2.364-.766h5.462v-.44A1.647,1.647,0,0,0,21.223,2H14.375C14.218,2,14.057,1.991,13.9,2Zm3.13,3.13a1.782,1.782,0,0,0-1.255.457L5.538,15.823a1.387,1.387,0,0,0-.408.978,1.35,1.35,0,0,0,.408.962l7.826,7.826a1.35,1.35,0,0,0,.962.408,1.387,1.387,0,0,0,.978-.408L25.543,15.351A2.27,2.27,0,0,0,26,13.622V6.775a1.647,1.647,0,0,0-1.647-1.647H17.505C17.348,5.128,17.187,5.122,17.032,5.128Zm4.793,3.13a1.043,1.043,0,1,1-.734.31A1.035,1.035,0,0,1,21.826,8.258Z" transform="translate(-2 -1.995)" fill="#fff" />
        </svg>
    );
};

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export default Label;
